import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { GridCellRenderer } from '../../abstraction/grid-cell-renderer';

@Component({
  selector: 'soft-margin-percent-renderer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './margin-percent-renderer.component.html',
  styleUrl: './margin-percent-renderer.component.css',
})
export class MarginPercentRendererComponent extends GridCellRenderer<object, string> {
  readonly percent = computed(() => {
    const raw = this.value();
    if (raw == null || raw === '') return null;
    const v = Number(raw);
    return isNaN(v) ? null : v;
  });

  readonly barWidth = computed(() => {
    const p = this.percent();
    if (p === null) return 0;
    return Math.min(Math.abs(p), 100);
  });

  readonly barColor = computed(() => {
    const p = this.percent() ?? 0;
    if (p < 0) return 'var(--ds-surface-status-danger)';
    if (p >= 30) return 'var(--ds-surface-status-success)';
    return 'var(--ds-surface-status-warning)';
  });

  readonly label = computed(() => {
    const p = this.percent();
    return p === null ? '' : `${p.toFixed(1).replace('.', ',')} %`;
  });
}
